import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import {
  IWarehouseRequest,
  IWarehouseResponse,
} from '../../models/warehouse/warehouse.model';
import useHttps from '../useHttps';

const useWareHouse = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const refreshTableContext = useContext(TableRefreshContext);
  const modalContext = useContext(ModalContext);

  const oncreateWarehouseError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const oncreateWarehouseSuccess = ({
    message,
  }: SuccessHttpResponse<IWarehouseResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createWarehouse = (data: IWarehouseRequest) => {
    const url: HttpConfig = {
      url: 'warehouse-service/api/v1/warehouses',
      method: 'post',
      data,
    };

    request(url, oncreateWarehouseSuccess, setLoading, oncreateWarehouseError);
  };

  return { createWarehouse, loading, resetInputFields };
};

export default useWareHouse;
